import { ChangeEventWorkflow } from "src/generated/graphqlTypes";
import {
  baseChangeEventFormConfig,
  BaseChangeEventFormInput,
  baseChangeEventMapToForm,
} from "src/routes/projects/change-events/guided/baseChangeEventForm";
import { GuidedChangeEventStep } from "src/routes/projects/change-events/guided/utils";
import { reviewStep } from "src/routes/projects/change-events/guided/workflows/sharedSteps/sharedSteps";
import { useGuidedChangeEventActions } from "src/routes/projects/change-events/guided/workflows/sharedSteps/useGuidedChangeEventActions";
import { useReviewStepActions } from "src/routes/projects/change-events/guided/workflows/sharedSteps/useReviewStepActions";
import { defineWorkflow } from "src/routes/projects/change-events/guided/workflows/types";

export const configurationTrueUpWorkflow = defineWorkflow<BaseChangeEventFormInput>({
  workflow: ChangeEventWorkflow.ConfigurationTrueUp,
  formConfig: baseChangeEventFormConfig,
  mapToForm: baseChangeEventMapToForm,
  steps: [
    {
      value: GuidedChangeEventStep.VersionUpdate,
      label: "Version Update",
      isComplete: () => true,
      render: () => <></>,
    },
    {
      value: GuidedChangeEventStep.DiscontinuedOptions,
      label: "Discontinued Options",
      isComplete: () => true,
      render: () => <></>,
    },
    reviewStep(),
  ],
  useActions: (args) => {
    const { saveChangeEvent } = useGuidedChangeEventActions(args);
    const { submit } = useReviewStepActions(args);
    return {
      onSubmit: submit,
      onContinue: {
        [GuidedChangeEventStep.VersionUpdate]: saveChangeEvent,
        [GuidedChangeEventStep.DiscontinuedOptions]: saveChangeEvent,
      },
      onSaveAndExit: args.form.value.id ? () => saveChangeEvent({ andExit: true }) : undefined,
    };
  },
});
